/** One card of the mocked corp surface. Its own file, as the
 *  one-component-per-file rule has it. */
import { EM_DASH, LEGEND, MONTH_SLOTS, ROWS, heading, subtle } from './corp-mock';

export function EventCalendarCard() {
  return (
    <section className="nb-card" style={{ flex: '0 0 auto' }}>
      <div className="nb-card-hd">
        <h3 className="nb-display" style={heading}>
          Event Calendar · Next 3 Months
        </h3>
        <div style={{ display: 'flex', gap: 10, fontSize: 10, color: subtle }}>
          {LEGEND.map((k) => (
            <span key={k.label}>
              <i
                style={{
                  display: 'inline-block',
                  width: 8,
                  height: 8,
                  borderRadius: 999,
                  background: k.tone,
                  marginRight: 4,
                  verticalAlign: '-1px',
                }}
              />
              {k.label}
            </span>
          ))}
        </div>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
        {MONTH_SLOTS.map((m) => (
          <div
            key={m}
            style={{
              padding: 12,
              background: 'var(--nb-surface)',
              border: '1px solid var(--nb-border)',
              borderRadius: 8,
              minHeight: 160,
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'baseline',
                justifyContent: 'space-between',
                marginBottom: 10,
              }}
            >
              <span className="nb-display" style={{ fontSize: 18, color: 'var(--nb-bark-dark)' }}>
                {EM_DASH}
              </span>
              <span style={{ fontSize: 11, color: subtle }}>{EM_DASH} events</span>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              {ROWS.slice(0, 2).map((r) => (
                <div
                  key={r}
                  style={{
                    padding: '6px 8px',
                    background: 'var(--nb-bg)',
                    borderRadius: 6,
                    borderLeft: `3px solid ${subtle}`,
                  }}
                >
                  <div style={{ fontSize: 11.5, fontWeight: 700, color: subtle }}>{EM_DASH}</div>
                  <div style={{ fontSize: 10, color: subtle, marginTop: 1 }}>{EM_DASH}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
